var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"NavLanguageSwitcherItem has-nowrap flex is-aligned-middle",class:{ 'text-brand': _vm.language === _vm.current }},[_c('language-flag',{staticClass:"m-r-s",attrs:{"language":_vm.language}}),_vm._v(" "+_vm._s(_vm.$t('components.language_switcher.languages.' + _vm.language))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }